<template>
  <div>
    <b-button
      @click="click"
      :disabled="disabled || loading"
      type="submit"
      class="button-style w-100 center"
      :class="`button-style--${variant}`"
    >
      <mdicon v-if="loading" name="loading" class="spinner" />
      <mdicon
        v-if="!loading && iconName"
        :name="iconName"
        size="26"
        class="mr-2"
        :class="iconClass"
      />
      <span v-if="!loading" v-text="title" :class="btnClass" />
    </b-button>
  </div>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    click: {
      type: Function,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    btnClass: {
      type: String,
      default: "font_25",
    },
    iconName: {
      type: String,
      default: "",
    },
    iconClass: {
      type: String,
      default: "",
    },
    variant: {
      type: String,
      default: "primary",
    },
  },
};
</script>